/**
 * Transition constants
 */

import {breakpointDesktop, breakpointFull, maxWidthTablet} from '~/src/css/global.module.scss';

/**
 * All possible responsive image sizes
 */
const ImageSize = {
    CONTENT: `(min-width: ${breakpointDesktop}) 997px, 100vw`,
    FULLSCREEN: '100vw',
    TEASER_FULL: `(min-width: ${breakpointFull}) 1158w, (min-width: ${breakpointDesktop}) 972w, (min-width: ${maxWidthTablet}) 728w, 100vw`,
    TEASER_LARGE: `(min-width: ${breakpointFull}) 766w, (min-width: ${breakpointDesktop}) 646w, (min-width: ${maxWidthTablet}) 728w, 100vw`,
    TEASER_SMALL: `(min-width: ${breakpointFull}) 380w, (min-width: ${breakpointDesktop}) 318w, (min-width: ${maxWidthTablet}) 236w, 50vw`,
    THUMBNAIL: '48px',
    TICKER: `(min-width: ${breakpointDesktop}) 749px, 100vw`
};

export {ImageSize};
